// File: src/pages/Success.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Success() {
  const navigate = useNavigate();
  const location = useLocation();
  const creditsAdded = location.state?.creditsAdded;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="p-6 border rounded-md bg-white">
        <h1 className="text-2xl font-semibold mb-2">Payment successful</h1>
        <p className="text-gray-700 mb-4">
          {creditsAdded
            ? `Added reviews: ${creditsAdded}`
            : "Your payment was successful and reviews were added to your account."}
        </p>
        <div className="flex gap-2">
          <button
            onClick={() => navigate("/dashboard/wallet")}
            className="px-4 py-2 bg-indigo-600 text-white rounded-md"
          >
            Back to Manage Payments
          </button>
     
        </div>
      </div>
    </div>
  );
}
